var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full flex justify-around gap-4 lg:gap-24"},_vm._l((_vm.randomProducts),function(card,key){return _c('ui-infobox-info-box-header',{key:key,attrs:{"card":card,"rotated":""}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }